(function () {
  'use strict';

  if (customElements.get('home-product-carousel')) return;

  class HomeProductCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-home-product-carousel-viewport]');
      this.previousButton = this.querySelector('[data-home-product-carousel-previous]');
      this.nextButton = this.querySelector('[data-home-product-carousel-next]');

      if (!this.viewport || !this.previousButton || !this.nextButton) return;

      this.onPrevious = () => this.scroll(-1);
      this.onNext = () => this.scroll(1);
      this.onScroll = () => this.queueControlUpdate();
      this.onResize = () => this.updateControls();
      this.onPointerDown = (event) => this.startDrag(event);
      this.onPointerMove = (event) => this.drag(event);
      this.onPointerUp = (event) => this.endDrag(event);
      this.onPointerCancel = (event) => this.endDrag(event);
      this.onDragStart = (event) => event.preventDefault();
      this.onClickCapture = (event) => {
        if (!this.suppressNextClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.suppressNextClick = false;
      };

      this.previousButton.addEventListener('click', this.onPrevious);
      this.nextButton.addEventListener('click', this.onNext);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerCancel);
      this.viewport.addEventListener('dragstart', this.onDragStart);
      this.viewport.addEventListener('click', this.onClickCapture, true);
      window.addEventListener('resize', this.onResize, { passive: true });

      this.updateControls();
    }

    disconnectedCallback() {
      if (!this.viewport) return;
      this.previousButton.removeEventListener('click', this.onPrevious);
      this.nextButton.removeEventListener('click', this.onNext);
      this.viewport.removeEventListener('scroll', this.onScroll);
      this.viewport.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport.removeEventListener('pointermove', this.onPointerMove);
      this.viewport.removeEventListener('pointerup', this.onPointerUp);
      this.viewport.removeEventListener('pointercancel', this.onPointerCancel);
      this.viewport.removeEventListener('dragstart', this.onDragStart);
      this.viewport.removeEventListener('click', this.onClickCapture, true);
      window.removeEventListener('resize', this.onResize);
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      if (this.clickResetTimer) window.clearTimeout(this.clickResetTimer);
    }

    scroll(direction) {
      var card = this.viewport.querySelector('[data-product-card], .product-card-placeholder');
      var cardWidth = card ? card.getBoundingClientRect().width : 0;
      var distance = Math.max(cardWidth, this.viewport.clientWidth - cardWidth);

      this.viewport.scrollBy({
        left: direction * distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    startDrag(event) {
      if (
        event.pointerType !== 'mouse' ||
        event.button !== 0 ||
        !window.matchMedia('(min-width: 62.125em)').matches
      ) {
        return;
      }

      this.dragPointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartScrollLeft = this.viewport.scrollLeft;
      this.didDrag = false;
      this.suppressNextClick = false;
      this.viewport.setPointerCapture(event.pointerId);
    }

    drag(event) {
      if (event.pointerId !== this.dragPointerId) return;

      var distance = event.clientX - this.dragStartX;
      if (!this.didDrag && Math.abs(distance) < 6) return;

      this.didDrag = true;
      this.viewport.classList.add('is-dragging');
      this.viewport.scrollLeft = this.dragStartScrollLeft - distance;
      event.preventDefault();
    }

    endDrag(event) {
      if (event.pointerId !== this.dragPointerId) return;

      if (this.viewport.hasPointerCapture(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }

      this.dragPointerId = null;
      this.viewport.classList.remove('is-dragging');

      if (!this.didDrag) return;

      this.suppressNextClick = true;
      this.clickResetTimer = window.setTimeout(() => {
        this.suppressNextClick = false;
        this.clickResetTimer = null;
      }, 0);
      this.queueControlUpdate();
    }

    queueControlUpdate() {
      if (this.updateFrame) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.updateControls();
      });
    }

    updateControls() {
      var maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      var current = this.viewport.scrollLeft;
      var tolerance = 2;

      this.previousButton.disabled = current <= tolerance;
      this.nextButton.disabled = current >= maximum - tolerance || maximum <= tolerance;
    }
  }

  customElements.define('home-product-carousel', HomeProductCarousel);
})();
